import { combineReducers } from 'redux';

const initialState = {
  value: 0,
  accessToken: null,
  isRefresh: false,
  userName: '',
  navigationWidth: 220
};

const locationInitialState = {
  loading: false, // false | 'families' | 'rooms' | 'devices'
  familyList: undefined,
  familyId: undefined,
  roomList: undefined,
  roomId: undefined,
  deviceList: undefined
};

const historyInitialState = {
  loading: false,
  startAt: null, // type: Date
  endAt: null, // type: Date
  deviceId: undefined,
  history: undefined
};

const hejhome = (state = initialState, action) => {
  switch (action.type) {
    case 'setAccessToken':
      return Object.assign({}, state, {
        accessToken: action.accessToken
      });
    case 'setIsRefresh':
      return Object.assign({}, state, {
        isRefresh: action.isRefresh
      });
    case 'setUserName':
      return Object.assign({}, state, {
        userName: action.userName
      });
    case 'setNavigationWidth':
      return Object.assign({}, state, {
        navigationWidth: action.navigationWidth
      });
    default:
      return state;
  }
};

const location = (state = locationInitialState, action) => {
  switch (action.type) {
    case 'setLocationLoading':
      return Object.assign({}, state, {
        loading: action.loading
      });
    case 'setFamilyList':
      return {
        ...state,
        familyList: action.families
        // roomList: undefined,
        // deviceList: undefined,
        // roomId: undefined
      };
    case 'setFamilyId':
      return {
        ...state,
        familyId: action.familyId,
        roomList: undefined,
        roomId: undefined,
        deviceList: undefined,
        deviceId: undefined
      };
    case 'setRoomList':
      return {
        ...state,
        roomList: action.roomList
        // deviceList: undefined,
        // roomId: undefined,
        // deviceId: undefined
      };
    case 'setRoomId':
      return {
        ...state,
        roomId: action.roomId,
        deviceList: undefined,
        deviceId: undefined
      };
    case 'setDeviceList':
      return {
        ...state,
        deviceList: action.deviceList
      };
    case 'setDeviceId':
      return {
        ...state,
        deviceId: action.deviceId
      };

    default:
      return state;
  }
};

const history = (state = historyInitialState, action) => {
  switch (action.type) {
    case 'setLoading':
      return {
        ...state,
        loading: action.loading
      };
    case 'setDate':
      return {
        ...state,
        startAt: action.startAt,
        endAt: action.endAt
      };
    case 'setHistory':
      return {
        ...state,
        history: action.history
      };
    case 'setHistoryRefresh':
      return {
        ...state
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  hejhome,
  location,
  history
});

export default reducer;
